"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextType = void 0;
/**
 * 文本类型
 */
var TextType;
(function (TextType) {
    TextType[TextType["TEXT"] = 0] = "TEXT";
    TextType[TextType["DATE"] = 1] = "DATE";
    TextType[TextType["EMOJI"] = 2] = "EMOJI";
    TextType[TextType["URL"] = 3] = "URL";
    TextType[TextType["LINK_PAGE"] = 4] = "LINK_PAGE";
    TextType[TextType["CODE"] = 5] = "CODE";
    TextType[TextType["DATETIME"] = 6] = "DATETIME";
    TextType[TextType["USER"] = 7] = "USER";
    TextType[TextType["EQUATION"] = 8] = "EQUATION";
    TextType[TextType["MENTION_BLOCK"] = 9] = "MENTION_BLOCK";
})(TextType = exports.TextType || (exports.TextType = {}));
